"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import MenuItems from "./MenuItems";
import UserPanel from "./userPanel";
import ThemeToggle from "./ThemeToggle";

export const BOOKING_URL = "/werkstatt-service";

const DesktopNav = () => {
    const pathname = usePathname();
    const mainLinks = MenuItems().filter((item) => item.main);

    const isActive = (url: string) =>
        url === "/" ? pathname === "/" : pathname?.startsWith(url);

    return (
        <header className="sticky top-0 z-40 hidden border-b border-ao-line bg-ao-bg/95 backdrop-blur-md lg:block">
            <nav
                aria-label="Hauptnavigation"
                className="mx-auto flex h-[84px] max-w-[1440px] items-center justify-between px-20"
            >
                {/* Logo + Schriftzug */}
                <Link href="/" className="flex items-center gap-3">
                    <img
                        src="/logo.png"
                        alt="A und O Autoservice"
                        className="h-10 w-10 rounded-[10px] object-cover"
                    />
                    <span className="flex flex-col leading-none">
                        <span className="font-display text-[22px] font-extrabold tracking-[0.04em] text-ao-fg">
                            A UND O
                        </span>
                        <span className="mt-1 text-[11px] font-semibold tracking-[0.22em] text-ao-muted">
                            AUTOSERVICE
                        </span>
                    </span>
                </Link>

                {/* Links */}
                <ul className="flex items-center gap-9 text-[15px] font-medium">
                    {mainLinks.map((item) => (
                        <li key={item.url}>
                            <Link
                                href={item.url}
                                aria-current={isActive(item.url) ? "page" : undefined}
                                className={`transition-colors ${
                                    isActive(item.url) ? "text-ao-fg" : "text-ao-muted hover:text-ao-fg"
                                }`}
                            >
                                {item.short}
                            </Link>
                        </li>
                    ))}
                </ul>

                {/* Hell/Dunkel/System, Anmelden / Profil, Termin buchen */}
                <div className="flex items-center gap-3">
                    <ThemeToggle />
                    <UserPanel />
                    <Link
                        href={BOOKING_URL}
                        className="inline-flex h-11 items-center rounded-[10px] bg-ao-accent px-[22px] text-[15px] font-bold text-ao-on-accent transition-colors hover:bg-ao-accent-hover"
                    >
                        Termin buchen
                    </Link>
                </div>
            </nav>
        </header>
    );
};

export default DesktopNav;
